import { Link, useLocation } from "react-router-dom";
import { dummyData } from "../index";
import { useMediaQuery } from 'react-responsive';

const SidebarItemsMathMode = () => {
  const location = useLocation();
  const isSmallScreen = useMediaQuery({ maxWidth: 670 });

  return (
    <div>
    <span style={{fontFamily: "Garamond, serif", fontSize: isSmallScreen ? "14px" : "20px", margin: "0px", color: "black"}}>Navigation:</span>
    <ul style={{
      listStyle: "none",
      paddingLeft: "0",
      margin: 0,
    }}>
      {dummyData.slice(0, -1).map((item, index) => (
        <li key={index}>
          <Link
            to={item.path}
            style={{
                fontWeight: location.pathname === item.path ? "bold" : "normal",
                fontFamily: "Garamond, serif", fontSize: isSmallScreen ? "10px" : "20px",
                textDecoration: "underline"
            }}
          >
            {item.name}
          </Link>
        </li>
      ))}
    </ul>
    </div>
  );
};

export default SidebarItemsMathMode;